import React from 'react';
import { Text } from '@clockout-dev/design-elements';
import styles from '../styles/availableBalanceSummaryCard.module.scss';

function formatValue(value) {
    if (!value) return '0%';
    const numeric = Number(value);
    const formatted = numeric.toFixed(0);
    return `${formatted}%`;
}

function DeductionRow({ label, value, accent, withDivider }) {
    const rowClass = `${styles.row} ${withDivider ? styles.rowDivider : ''}`.trim();
    return (
        <div className={rowClass}>
            <Text as="span" size="s" className={styles.rowLabel}>
                {label}
            </Text>
            <Text as="span" size="s" className={accent ? styles.rowValueAccent : styles.rowValue}>
                {formatValue(value)}
            </Text>
        </div>
    );
}

function DeductionsSection({
    userTenureValue,
    overdraftValue,
    achValue,
    employmentValue,
    balanceValue,
    finalThreshold,
}) {
    const finalThresholdLabel =
        finalThreshold === undefined || finalThreshold === null
            ? '—'
            : `${Number(finalThreshold).toFixed(0)}%`;

    return (
        <div className={styles.deductionsBlock}>
            <Text as="span" size="xs" className={styles.deductionsTitle}>
                Rule Adjustments
            </Text>
            <DeductionRow label="User Tenure" value={userTenureValue} accent />
            <DeductionRow label="Overdraft/NSF" value={overdraftValue} />
            <DeductionRow label="ACH Return" value={achValue} />
            <DeductionRow label="Product Type" value={employmentValue} />
            <DeductionRow label="Avg. Daily Balance" value={balanceValue} withDivider />
            <div className={styles.row}>
                <Text as="span" size="xs" className={styles.finalLabel}>
                    Final Threshold
                </Text>
                <Text as="span" size="s" className={styles.finalThresholdValue}>
                    {finalThresholdLabel}
                </Text>
            </div>
        </div>
    );
}

export default DeductionsSection;
